export default __webpack_public_path__ + "static/media/18.47dbc6f4.png";